"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pluralize = void 0;
const pluralRules = new Intl.PluralRules("en-US");
const pluralize = (count, singular, plural) => {
    const grammaticalNumber = pluralRules.select(count);
    switch (grammaticalNumber) {
        case "one":
            return count + " " + singular;
        case "other":
            return count + " " + plural;
        default:
            throw new Error("Unknown: " + grammaticalNumber);
    }
};
exports.pluralize = pluralize;
